(function() {
    
    /**
     * Animate
     */

    const navigation = document.querySelector('.navigation');
    const heroLights = document.querySelector('.hero-lights');
    const heroTitle = document.querySelector('.hero-title');
    const heroDescription = document.querySelector('.hero-description');
    const pickDoor = document.querySelector('.pick-door');
    const footerCta = document.querySelector('.footer-cta');

    gsap.registerPlugin(ScrollTrigger);
    let tl = gsap.timeline();

    if(navigation) {
        tl.from('.navigation', {
            duration: 1, 
            y: -60, 
            opacity: 0,
            ease: 'power2'
        }, 0);
    }

    if(heroLights) {
        tl.fromTo('.hero-lights', {
            opacity: 0,
            y: 40,
            scale: 1.1
        }, {
            duration: 1,
            y: 140,
            opacity: 1,
            ease: 'power2'
        }, 0);

        tl.to('.hero-lights', {
            scale: 1,
            y: '40%',
            ease: 'power2',
            duration: 1
        }, 3.5 );
    }

    
    if(heroTitle) {
        tl.fromTo('.hero-title', {
            opacity: 0,
            y: 40,
            scale: 1.1
        }, {
            duration: 1,
            y: 140,
            opacity: 1,
            ease: 'power2'
        }, 0);
    
        tl.to('.hero-title', {
            scale: 1,
            y: '40%',
            ease: 'power2',
            duration: 1
        }, 3.5);
    }
    
    if(heroDescription) {
        tl.from('.hero-description', {
            duration: 1,
            y: 60, 
            opacity: 0,
            ease: 'power2'
        }, 4);
    }
    
    if(pickDoor) {
        tl.from('.pick-door', {
            duration: 1,
            y: 0,
            opacity: 0,
            ease: 'power2'
        }, 5);
    }
    
    if(footerCta) {
        tl.from('.footer-cta', {
            duration: 1,
            y: -10,
            opacity: 0,
            ease: 'power2'
        }, 2.5);
    }

    
    /**
     * Go back to the page when video ends
     */
    let doorVideo = document.getElementById('doorVideo');

    if(doorVideo) {
        doorVideo.addEventListener('ended', function(e) {
            window.location.replace('/sayonara-2020/after-video.html');
        });
    }
    
    /**
     * Background video mute toggle
     */
    let backgroundVideo = document.getElementById('backgroundVideo')
        muteButton = document.getElementById('muteButton');

    if(backgroundVideo) {
        muteButton.addEventListener('click', function(e) {
            backgroundVideo.muted = !backgroundVideo.muted;
            if(backgroundVideo.muted) {
                muteButton.classList.remove('on');
            } else {
                muteButton.classList.add('on');
            }
        });
    }

    /**
     * Change string style
     */

    let changeText = function(target, word) {
        var html = target.innerHTML;
        html = html.replace(new RegExp(word, 'g'), '<span class="red">'+word+'</span>');
        target.innerHTML = html;
    };

    changeText(document.querySelector('.hero-body'), 'Children’s National Hospital Foundation');


}())